import {
  EditFilled,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Space,
} from "antd";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

function ContactsModal({ contacts = [] }) {
  const [data, setData] = useState([]);
  const [updatedData, setUpdatedData] = useState(null);

  useEffect(() => {
    setData(contacts);
  }, [contacts]);

  const handleUpdate = async (values) => {
    let updatedContacts = [...values.contacts, ...values.new_contacts].map(
      (item, idx) => {
        return {
          ...item,
          label_key: `contact_number_${idx + 1}_label`,
          number_key: `contact_number_${idx + 1}`,
        };
      }
    );
    let res = await apiRequest({
      path: apiPaths.siteSettings + "/contacts",
      method: "PUT",
      data: updatedContacts,
    });

    if (res.error) {
      message.error(res.error_description);
      return;
    }
    setData([...updatedContacts]);
    setUpdatedData(null);
  };

  return (
    <div style={{ width: 350, padding: 20 }}>
      <div
        style={{
          display: "flex",
          marginBottom: 10,
          justifyContent: "space-between",
        }}
      >
        <div style={{ fontSize: 20 }}>Contacts</div>
        <Button
          type="link"
          onClick={() => {
            setUpdatedData(contacts);
          }}
        >
          <EditFilled />
        </Button>
      </div>
      <div style={{ border: "1px solid #b7b7b750" }}>
        <Row
          style={{
            padding: 5,
            borderBottom: "1px solid #b7b7b750",
          }}
        >
          <Col span={10} style={{ fontWeight: "bold", padding: 5 }}>
            {"Name"}
          </Col>
          <Col
            span={14}
            style={{
              fontWeight: "bold",
              borderLeft: "1px solid #b7b7b730",
              padding: 5,
            }}
          >
            {"Contact"}
          </Col>
        </Row>
        {data.map((item, idx) => (
          <Row
            style={{
              padding: 5,
              borderBottom: "1px solid #b7b7b730",
            }}
            key={idx}
          >
            <Col span={10} style={{ padding: 5 }}>
              {item.label}
            </Col>
            <Col span={14} style={{ padding: 5 }}>
              {item.number}
            </Col>
          </Row>
        ))}
      </div>

      {updatedData ? (
        <Modal
          title={"Update Contacts"}
          centered
          width={500}
          visible={true}
          onCancel={() => {
            setUpdatedData(null);
          }}
          footer={null}
        >
          <Row gutter={[12, 12]}>
            <Col span={11} style={{ fontWeight: "bold" }}>
              {"Name"}
            </Col>
            <Col span={11} style={{ fontWeight: "bold" }}>
              {"Contact"}
            </Col>
          </Row>
          <Form
            name="dynamic_form_nest_item"
            onFinish={handleUpdate}
            style={{
              maxWidth: 600,
            }}
            initialValues={{
              contacts: updatedData,
              new_contacts: [],
            }}
            autoComplete="off"
          >
            <Form.List name="contacts">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, idx) => (
                    <Row key={key} gutter={[12, 12]}>
                      <Col span={11}>
                        <Form.Item
                          {...restField}
                          name={[name, "label"]}
                          rules={[
                            {
                              required: true,
                              message: "Missing name",
                            },
                          ]}
                        >
                          <Input placeholder="Name" />
                        </Form.Item>
                      </Col>
                      <Col span={11}>
                        <Form.Item
                          {...restField}
                          name={[name, "number"]}
                          rules={[
                            {
                              required: true,
                              message: "Missing contact",
                            },
                          ]}
                        >
                          <Input placeholder="Contact" />
                        </Form.Item>
                      </Col>
                      <Col span={2}></Col>
                    </Row>
                  ))}
                </>
              )}
            </Form.List>
            <Form.List name="new_contacts">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, idx) => (
                    <Row key={key} gutter={[12, 12]}>
                      <Col span={11}>
                        <Form.Item
                          {...restField}
                          name={[name, "label"]}
                          rules={[
                            {
                              required: true,
                              message: "Missing name",
                            },
                          ]}
                        >
                          <Input placeholder="Name" />
                        </Form.Item>
                      </Col>
                      <Col span={11}>
                        <Form.Item
                          {...restField}
                          name={[name, "number"]}
                          rules={[
                            {
                              required: true,
                              message: "Missing contact",
                            },
                          ]}
                        >
                          <Input placeholder="Contact" />
                        </Form.Item>
                      </Col>
                      <Col span={2}>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Col>
                    </Row>
                  ))}
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() => add()}
                      block
                      icon={<PlusOutlined />}
                    >
                      Add Contact
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
            <Form.Item>
              <Space style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  onClick={() => {
                    setUpdatedData(null);
                  }}
                >
                  Cancel
                </Button>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      ) : null}
    </div>
  );
}

export default ContactsModal;
